import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { truncate } from "../../../utils/service";

const CollectionCardItem = ({
  title,
  description = null,
  linkTo = null,
  onSurface = false,
  images = [],
}) => {
  // let images = [
  // "https://api.nott.one/files/user/cloud/d57e1478fadce2cb0a7f451a0a9ac592.gif",
  // "https://api.nott.one/files/user/cloud/ee09bca391a874373b6f769a5edb3ea4.jpg",
  // "https://api.nott.one/files/user/cloud/ef2d0f824ec2430874b60bcc13895b11.jpg",
  // "https://api.nott.one/files/user/cloud/e66f1a8d68bead67f901ab4ba10871ee.jpg",
  // ];

  const allImages = [...images, ...images, ...images, ...images]; // удваиваем для бесконечности

  return (
    <div className="col s12 l4">
      <Link to={linkTo}>
        <div
          className={
            onSurface
              ? "card mb30 hand-cursor bg animation-appear"
              : "card mb30 blur-card hand-cursor animation-appear"
          }
          style={{ minHeight: "250px", overflow: "hidden" }}
        >
          <div className="card-content" style={{ padding: "0px" }}>
            <div
              className="row nm blur-card blur-card-smooth"
              style={{
                position: "absolute",
                zIndex: 10,
                minWidth: "100%",
                marginLeft: "0px",
              }}
            >
              <div
                className="col s12 l12 mb10 xxl700"
                style={{
                  paddingLeft: "22px",
                  paddingRight: "30px",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                  marginTop: "5px",
                  // marginBottom: "-20px",
                }}
              >
                {truncate(title, 50)}
              </div>
            </div>
            <div className="card-slider-wrapper">
              <div className="card-slider-track-inverse">
                {allImages.map((src, index) => (
                  <img
                    key={`${index}-${src}`}
                    src={src}
                    alt={`img-${index}`}
                    className="card-slider-img"
                  />
                ))}
              </div>
            </div>

            <div className="card-slider-wrapper">
              <div className="card-slider-track">
                {allImages.map((src, index) => (
                  <img
                    key={`${index}-${src}`}
                    src={src}
                    alt={`img-${index}`}
                    className="card-slider-img"
                  />
                ))}
              </div>
            </div>

            <div className="card-slider-wrapper">
              <div className="card-slider-track-inverse">
                {allImages.map((src, index) => (
                  <img
                    key={`${index}-${src}`}
                    src={src}
                    alt={`img-${index}`}
                    className="card-slider-img"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CollectionCardItem;
